import { render, staticRenderFns } from "./NotifRemovedFromCommunity.vue?vue&type=template&id=dd7f94da&scoped=true"
import script from "./NotifRemovedFromCommunity.vue?vue&type=script&lang=js"
export * from "./NotifRemovedFromCommunity.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=dd7f94da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7f94da",
  null
  
)

export default component.exports